import { CommissionReportsGenerationStatus } from "nvent-web/types/CommissionReportsGenerationStatus";

export const ROOM_STOP_POLLING_STATUSES = [
  CommissionReportsGenerationStatus.frozen,
  CommissionReportsGenerationStatus.generated,
];

export const STOP_POLLING_STATUSES = [...ROOM_STOP_POLLING_STATUSES, CommissionReportsGenerationStatus.noRooms];
